import _Colors from "./Colors";
import _Keys from "./Keys";

export const Colors: any = _Colors;
export const Keys: any = _Keys;

export default {
    Colors,
    Keys,
}
